import { useState } from "react";

const Hero1 = ({ data }) => {
    const [item0, item1, item2] = data.items;

    return (
        <section className="max-w-full mx-auto px-4 lg:w-[70%] lg:max-w-[1440px] lg:px-0 py-1 pb-20 max-sm:pb-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* 左侧：item0，文字底部 */}
            <div className="relative rounded-xl shadow-md overflow-visible">
                <img
                    src={item0.img}
                    alt={item0.title}
                    className="w-full h-auto object-contain"
                />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h2 className="text-2xl font-bold mb-2">{item0.title}</h2>
                    <p className="text-gray-700 text-sm sm:text-lg leading-relaxed sm:leading-loose">{item0.subTitle}</p>
                </div>
            </div>

            {/* 右侧：item1 & item2，文字顶部 */}
            <div className="flex flex-col gap-8 h-full">
                {[item1, item2].map((item, idx) => (
                    <div
                        key={idx}
                        className="relative rounded-xl shadow-md overflow-hidden flex-1 min-h-[400px]"
                    >
                        {/* 图片绝对铺满 */}
                        <img
                            src={item.img}
                            alt={item.title}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        {/* 文字覆盖，保证在图片上 */}
                        <div className="relative p-6 z-10">
                            <h2 className="text-2xl font-bold mb-2">{item.title}</h2>
                            <p className="text-gray-700 text-sm sm:text-lg leading-tight">{item.subTitle}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Hero1;
  
  
  
